export const ResourceType = {
    GIG: 'GIG',
    SELLER: 'SELLER',
};
